import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { AlertRowComponent } from "./alert-row/alert-row.component";
import { Alert } from "../../../@core/data/alert";
import { AlertService } from "../../../@core/api/alert.service";
import { NbWindowService, NbWindowState } from "@nebular/theme";
import { LenguageService } from "../../../@core/utils/lenguage.service";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-alerts-table",
  templateUrl: "./alerts-table.component.html",
  styleUrls: ["./alerts-table.component.scss"],
})
export class AlertsTableComponent implements OnInit {
  filters: any;
  @Input() type: string;
  @Input() assigned: boolean = false;
  alerts: Alert[];
  lastPage: boolean;
  loading: boolean;
  pageNumberShow: number = 1;
  pagination = {
    perPage: 100,
    pageNumber: 0,
  };
  order = {
    field: "timestamp",
    direction: "desc",
  };
  range: any;
  selectedRowId: string = "";
  addFilter: boolean = false;
  dateRange: {
    dateStart: number;
    dateEnd: number;
  };

  constructor(
    private windowService: NbWindowService,
    private router: Router,
    private alertService: AlertService,
    public language: LenguageService
  ) {}

  async ngOnInit() {
    this.getAlerts();
  }

  nextPage() {
    if (!this.lastPage && !this.loading) {
      this.pagination.pageNumber++;
      this.getAlerts();
      this.pageNumberShow++;
    }
  }

  prevPage() {
    if (this.pagination.pageNumber > 0 && !this.loading) {
      this.pagination.pageNumber--;
      this.getAlerts();
      this.pageNumberShow--;
    }
  }

  selectRow(data) {
    console.log(data);
    if (data.select) {
      this.selectedRowId = data.id;
    } else {
      this.selectedRowId = "";
    }
    /* 
        let leads = this.leads;
        this.leads = [];
        this.leads = leads; */
  }

  async getAlerts() {
    this.loading = true;
    this.alerts = <Alert[]>(
      await this.alertService.getAlerts(
        this.pagination,
        this.filters,
        this.order
      )
    );
    this.loading = false;

    if (this.alerts.length < this.pagination.perPage) {
      this.lastPage = true;
    } else {
      this.lastPage = false;
    }
  }

  async createAlert() {
    this.loading = true;
    this.loading = false;
    this.router.navigate(["home", "alert"]);
  }

  rangeChanged() {
    let dateEnd = new Date(this.range.end).getTime() + 24 * 60 * 60 * 1000;
    let dateStart = (new Date(this.range.start).getTime() * 1000) / 1000;
    this.filters.dateRange = { dateStart, dateEnd };
  }

  async removeFilters() {
    this.dateRange = undefined;
    this.filters = undefined;
    this.addFilter = false;
    await this.getAlerts();
  }
}
